import React, { Component } from "react"
import { Modal, Form, Input, Button } from "antd";
import { toast } from "react-toastify";
import * as Yup from 'yup';
import * as IntlTelInput from 'intl-tel-input';
import * as firebase from 'firebase/app';
import 'firebase/auth';

toast.configure({
    position: "bottom-right"
});

const PHONE_OR_EMAIL = {
	phone: "phone",
	email: "email"
}

class SignInModal extends Component {
	
	emailRegex = RegExp(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);    
    passwordRegex = RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/);
    phoneRegex = RegExp(/^\+(?:[0-9]●?){6,14}[0-9]$/);

    state = {
        signInState: false,
        email: "",
		password: "",
		phoneNumber: "",
		currentType: PHONE_OR_EMAIL.email,
		countries: [],
        errors: {
            email: null,
			password: null,
			phoneNumber: null
        }
	}

	phoneNumberRef = React.createRef()
	ini_ = null;
	recaptchaVerifier = null;

	componentDidMount(){
		console.log(document.getElementById("phoneNumber"));
	}

	componentDidUpdate(prevProps, prevState){
		const this_ = this;
		if(this.state.countries.length === 0 && prevState.countries.length === 0){
			if(this.state.currentType === PHONE_OR_EMAIL.phone){
				const input = document.getElementById("phoneNumber");
                firebase.auth().useDeviceLanguage();
                this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier("signInRecaptchaContainer", {
                    'size': 'invisible'
                });
                this.recaptchaVerifier.render();

				this.ini_ = IntlTelInput(input, {
                    preferredCountries: [],
                    separateDialCode: true
                });
                this_.setState({
                    dialCode: this_.ini_.getSelectedCountryData().dialCode
                })
                input.addEventListener("countrychange", function() {
                    this_.setState({
                        dialCode: this_.ini_.getSelectedCountryData().dialCode
                    }) 
                });
				try {
					const countries = window.intlTelInputGlobals.getCountryData();
					this.setState({
						countries
					})
				} catch(error){
					toast("Something went wrong!", { type: "error"});
				} 
			}
		}

		if(prevProps.visible && this.props.visible){
			this.resetForm();
		}

		console.log(prevProps, this.props);
	}
	
	switchType = () => {
		this.setState({
			currentType: this.state.currentType === PHONE_OR_EMAIL.email ? PHONE_OR_EMAIL.phone : PHONE_OR_EMAIL.email
		})
	}

    passwordSchema = Yup.string()
        .required("Your password is required.")
        .min(6, "A strong password should be a minimum of 6 characters.")
        .matches(this.passwordRegex, "A strong password should include a number, capital letters and small letters.")

    emailSchema = Yup.string()
        .required("Your email is required.")
        .email("Please enter a valid email.");

    phoneSchema = Yup.string()
        .required("Your phone number is required.")
        .matches(this.phoneRegex, "Please enter a valid phone number.")
    
    emailValidationSchema = Yup.object().shape({
        password: this.passwordSchema,
        email: this.emailSchema,
    })

    phoneValidationSchema = Yup.object().shape({
        phoneNumber: this.phoneSchema,
    })

    handleSubmit =  async (event) => {
		if(this.state.currentType === PHONE_OR_EMAIL.email){
			this.emailValidationSchema.validate({
				email: this.state.email,
				password: this.state.password
			}).then( res => {
				this.setState({
					errors: {}
				});
				this.props.onCreate({
					email: this.state.email,
					password: this.state.password
				});
			}).catch( res => {
				if(res.errors.length > 0){
					this.setState({
						errors: {
							[res.path]: res.message
						}
					});
				}
			})
		} else {
			this.phoneValidationSchema.validate({
				phoneNumber: `+${this.state.dialCode}${this.state.phoneNumber}`,
			}).then( res => {
				this.setState({
					errors: {}
				});
				this.props.signInWithPhone({
					phone: `+${this.state.dialCode}${this.state.phoneNumber}`,
					recaptchaVerifier: this.recaptchaVerifier
				});
			}).catch( res => {
				if(res.errors && res.errors.length > 0){
					this.setState({
						errors: {
							[res.path]: res.message
						}
					});
				}
			})
		}
        
	}
	
	handleChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value
		})
	}

	handleCancel = (event) => {
		this.props.onCancel(event);
		this.resetForm()
	}

	resetForm = () => {
	}

	formRef = React.createRef()

	render() {
		return (
			<React.Fragment>
				<Modal
					className='login_block'
					visible={this.props.visible}
					okText='Recover'
					onCancel={this.handleCancel}
					footer={null}
				>
					<div className='modalPayment'>
						<div className='signInDescription'>
							<img
								alt="graduation cap"
								width='50px'
								height='50px'
								src={require("../icons/user-graduate.svg")}
							></img>
						</div>
						<div className='signInDescription'>

						{/* <div className='signInDescription'> */}
							<p
								className='createAccount'
								onClick={this.switchType}
							>
								{
									this.state.currentType === PHONE_OR_EMAIL.email ? 
										"Sign In with a Phone Number" :
										"Sign In with an Email"
								}
							</p>
						{/* </div> */}
						{
							this.state.currentType === PHONE_OR_EMAIL.phone ? 
								"We’ll send you a code to sign in to your account." : 
								"We’ll send you a link to sign in to your account." 
						}
						</div>
						<div className='loginForm'>
							<Form
								ref={this.props.formRef}
								labelCol={{ span: 5 }}
								wrapperCol={{ span: 12 }}
								onFinish={this.handleSubmit}
							>
								<div className='centralButton'>
									<Form.Item
										style={{display: this.state.currentType === PHONE_OR_EMAIL.phone ? "block" : "none"}}
										hasFeedback={this.state.errors.phoneNumber != null}
										validateStatus={this.state.errors.phoneNumber != null ? "error" : "success"}
										help={this.state.errors.phoneNumber != null ? this.state.errors.phoneNumber : ""}
										name="phoneNumber"
										rules={[
										{
											required: this.state.currentType === PHONE_OR_EMAIL.phone ? true : false,
											message: 'Please input your phone number!',
										},
										]}
									>
										<Input
											name="phoneNumber"
											id="phoneNumber"
											value={this.state.phoneNumber}
											onChange={this.handleChange}
											style={{
												width: '100%',
											}}
										/>
									</Form.Item> 
									<Form.Item
										style={{display: this.state.currentType === PHONE_OR_EMAIL.phone ? "none" : "block"}}
										hasFeedback={this.state.errors.email != null}
										validateStatus={this.state.errors.email != null ? "error" : "success"}
										help={this.state.errors.email != null ? this.state.errors.email : ""}
									>
										<Input
											type='email'
											name="email"
											id="email"
											value={this.state.email}
											onChange={this.handleChange}
											placeholder='Email'
										/>
									</Form.Item>
									<Form.Item
										style={{display: this.state.currentType === PHONE_OR_EMAIL.phone ? "none" : "block"}}
                                        hasFeedback={this.state.errors.password != null}
                                        validateStatus={this.state.errors.password != null ? "error" : "success"}
                                        help={this.state.errors.password != null ? this.state.errors.password : ""}
									>
										<Input
											type='password'
											name="password"
											id="password"
											value={this.state.password}
											onChange={this.handleChange}
											placeholder='Password'
										/>
									</Form.Item>
								</div>
                                <div 
                                    id="signInRecaptchaContainer"
                                    style={{display: this.state.currentType === PHONE_OR_EMAIL.phone ? "block" : "none"}}
                                ></div>
								<div className='centralButton'>
									<Form.Item>
										<Button
											className='coinButton profileApply'
											type='primary'
											htmlType='submit'
										>
											Sign In
										</Button>
									</Form.Item>
								</div>
								<div className='signInDescription'>
									Or
									<br />
                            		<br />
									<span
										className='createAccount'
										onClick={this.props.openSignUp}
									>
										Sign Up{" "}
									</span>
								</div>
							</Form>
						</div>
					</div>
				</Modal>
			</React.Fragment>
		)
	}
}

export default SignInModal
